/* Curnis theme — interazioni */
(function () {
  "use strict";
  var clamp = function (v, a, b) { a = a == null ? 0 : a; b = b == null ? 1 : b; return Math.min(b, Math.max(a, v)); };
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ------------- LE BARRE IN FONDO E IL PULSANTE WHATSAPP -------------
     Due barre si appoggiano al bordo basso dello schermo: gli inviti della
     scheda prodotto (.pd-actions) e il banner della scheda diamante
     (.cp3-flot). Tutte e due stanno nell'angolo del pulsante WhatsApp.

     Qui c'era il codice che ne misurava l'altezza, perche' la barra era
     "fixed" e bisognava rifare spazio nel piede della pagina. Adesso e'
     "sticky", sta nel flusso e lo spazio se lo prende da sola: resta solo da
     dire al pulsante WhatsApp quando togliersi di mezzo.

     Si guarda la geometria a ogni scorrimento, non un IntersectionObserver:
     e' lo stesso modo in cui lavora l'intestazione qui sotto, e per la stessa
     ragione — le barre sono "sticky", quindi incollate al bordo basso non
     escono mai dalla zona osservata e un osservatore non tornerebbe mai
     indietro. Il conto e' banale: la barra e' in vista se il suo riquadro
     interseca lo schermo. */
  (function () {
    var barre = [].slice.call(document.querySelectorAll(".pd-actions, .cp3-flot"));
    if (!barre.length) return;
    var giro = 0;
    function guarda() {
      giro = 0;
      var vista = barre.some(function (b) {
        /* la barra della pietra nasce con hidden: finche' non si apre una
           scheda non c'e' niente da cui togliersi di mezzo */
        if (b.hidden) return false;
        var r = b.getBoundingClientRect();
        if (!r.height) return false;
        return r.bottom > 0 && r.top < (window.innerHeight || 0);
      });
      document.body.classList.toggle("barra-in-vista", vista);
    }
    function chiedi() { if (!giro) giro = requestAnimationFrame(guarda); }
    window.addEventListener("scroll", chiedi, { passive: true });
    window.addEventListener("resize", chiedi);
    window.addEventListener("load", guarda);
    /* la scheda della pietra si apre e si chiude senza ricaricare la pagina:
       quando .cp3-flot smette di essere hidden nessuno scorrimento avviene */
    if (window.MutationObserver) {
      barre.forEach(function (b) {
        new MutationObserver(guarda).observe(b, { attributes: true, attributeFilter: ["hidden", "class", "style"] });
      });
    }
    guarda();
  })();

  /* ------------- FRECCE DELLA GALLERIA PRODOTTO -------------
     Il binario si sfoglia col dito; queste due dicono che c'e' altro da
     vedere, e dal 20 settembre 2026 GIRANO IN TONDO: dall'ultima fotografia
     si torna alla prima e viceversa. Chiesto cosi' — «due pulsanti per andare
     a sinistra o a destra, le foto scorrono in qualsiasi direzione» — e con il
     giro in tondo cade la ragione per cui prima sparivano ai capi: adesso ogni
     freccia porta sempre da qualche parte, quindi restano tutt'e due accese.

     LA POSIZIONE SI CALCOLA SULL'INDICE, non sommando larghezze. Lo
     scorrimento con aggancio a scatto non finisce mai esattamente sul pixel
     giusto: sommando una larghezza per volta l'errore si accumula e dopo
     qualche scatto l'aggancio salta una fotografia. Arrotondando la posizione
     attuale alla fotografia piu' vicina, invece, ogni colpo riparte da zero. */
  (function () {
    var binario = document.querySelector(".pd-stack");
    var frecce = [].slice.call(document.querySelectorAll("[data-pd-frec]"));
    if (!binario || !frecce.length) return;
    frecce.forEach(function (b) {
      b.hidden = false;
      b.addEventListener("click", function () {
        var passo = binario.clientWidth;
        if (!passo) return;
        var quante = Math.max(1, Math.round(binario.scrollWidth / passo));
        var qui = Math.round(binario.scrollLeft / passo);
        var verso = parseInt(b.getAttribute("data-pd-frec"), 10);
        /* il resto di una somma negativa in JavaScript e' negativo: si aggiunge
           un giro prima di prendere il resto, o dalla prima si finirebbe fuori */
        var poi = ((qui + verso) % quante + quante) % quante;
        binario.scrollTo({ left: poi * passo, behavior: "smooth" });
      });
    });
  })();

  /* ------------- SECONDA FOTOGRAFIA MENTRE IL DITO E' SOPRA -------------
     Sul telefono non c'e' il passaggio del mouse, quindi la seconda foto della
     scheda non compariva mai.

     DUE TENTATIVI SBAGLIATI, per non rifarli: prima ho guardato se la scheda
     fosse dentro allo schermo al 65% — ne restavano accese sei o otto insieme
     e non tornavano piu' indietro. Poi una fascia alta il 12% in mezzo allo
     schermo — meglio, ma la fotografia restava accesa finche' non si scorreva
     di nuovo, perche' la fascia si muove solo se si muove la pagina.

     Non e' lo scorrimento a doverla chiamare: e' il dito. Si accende quando il
     dito si appoggia sulla scheda e si spegne quando lo si alza, che e'
     esattamente il passaggio del mouse tradotto in gesto.

     Un gestore solo, sul documento: le schede cambiano a ogni filtro e a ogni
     pagina, e riattaccarne uno per scheda vorrebbe dire rincorrerle. */
  if (window.matchMedia("(hover: none)").matches) {
    var scheda = null, timer = null, x0 = 0, y0 = 0;

    var spegni = function () {
      if (timer) { clearTimeout(timer); timer = null; }
      if (scheda) { scheda.classList.remove("e-al-centro"); scheda = null; }
    };

    document.addEventListener("touchstart", function (e) {
      spegni();
      var c = e.target.closest && e.target.closest(".card");
      if (!c || !c.querySelector(".card__media--duo")) return;
      x0 = e.touches[0].clientX;
      y0 = e.touches[0].clientY;
      scheda = c;
      c.classList.add("e-al-centro");
      /* E POI TORNA INDIETRO DA SOLA (chiesto il 10 set 2026). Un secondo e
         mezzo: il tempo di guardare l'altro scatto. Senza questo, tenendo il
         dito fermo la scheda restava sulla seconda fotografia a oltranza. */
      timer = setTimeout(spegni, 1500);
    }, { passive: true });

    /* SE IL DITO SI MUOVE, SI STA SCORRENDO: la seconda fotografia si spegne
       subito. E' questa riga a fare la differenza fra "la guardo" e "sto
       passando di qui": dieci pixel sono il tremolio di un dito fermo, non
       l'inizio di uno scorrimento. */
    document.addEventListener("touchmove", function (e) {
      if (!scheda) return;
      var t = e.touches[0];
      if (Math.abs(t.clientX - x0) > 10 || Math.abs(t.clientY - y0) > 10) spegni();
    }, { passive: true });

    document.addEventListener("touchend", spegni, { passive: true });
    document.addEventListener("touchcancel", spegni, { passive: true });
    window.addEventListener("scroll", spegni, { passive: true });
    /* la pagina puo' anche cambiare sotto: se la scheda porta via, l'ultimo
       fotogramma non deve restare quello sbagliato */
    window.addEventListener("blur", spegni);
  }

  /* Qui il blocco delle frecce della galleria era scritto UNA SECONDA VOLTA,
     identico. Due gestori sullo stesso pulsante: ogni clic chiamava scrollBy
     due volte e la galleria saltava due fotografie invece di una. Resta la
     copia in cima al file. */


  /* QUI C'ERA UN SECONDO MECCANISMO, ed era lui il difetto (10 set 2026).
     Un IntersectionObserver accendeva .e-al-centro su ogni scheda che
     attraversava una fascia in mezzo allo schermo. Quando e' arrivato il
     gestore del dito, qui sopra, questo non e' stato tolto: i due giravano
     insieme, e mentre si scorreva le schede passavano alla seconda
     fotografia da sole — "come se dove premo resta memorizzato e poi quando
     scrollo man mano appaiono le secondarie". Comanda solo il dito. */

  /* ---------------- HEADER ---------------- */
  var header = document.querySelector(".header");
  var megaOpen = false;
  function refreshHeader() {
    if (!header) return;
    var hero = document.querySelector("[data-hero]");
    var onHero = hero ? hero.getBoundingClientRect().bottom > 88 : false;
    header.classList.toggle("is-on-hero", onHero && !megaOpen);
    header.classList.toggle("is-solid", !onHero || megaOpen);
  }
  window.addEventListener("scroll", refreshHeader, { passive: true });
  window.addEventListener("resize", refreshHeader);

  /* ---------------- MENU MOBILE a due livelli ----------------
     Il secondo livello entra da destra e si sovrappone al primo. Chiudendo il
     menu si torna sempre al primo: riaprirlo e ritrovarsi dentro "Orologi"
     senza sapere perche' e' il modo piu' rapido di disorientare qualcuno. */
  var burger = document.querySelector(".burger");
  var mnav = document.querySelector("[data-mnav]");
  if (burger && mnav) {
    var lv1 = mnav.querySelector("[data-mnav-lv1]");
    var pannelli = [].slice.call(mnav.querySelectorAll("[data-mnav-panel]"));
    var apertoOra = null;

    function chiudiLivello2(subito) {
      if (!apertoOra) return;
      var p = apertoOra;
      apertoOra = null;
      p.classList.remove("is-in");
      if (subito) { p.hidden = true; return; }
      /* aspetto che finisca di uscire prima di toglierlo, altrimenti sparisce
         di colpo invece di scorrere via */
      setTimeout(function () { if (!p.classList.contains("is-in")) p.hidden = true; }, 400);
    }

    function apri(nome) {
      var p = mnav.querySelector('[data-mnav-panel="' + nome + '"]');
      if (!p) return;
      p.hidden = false;
      /* Leggere una misura forza il browser a ricalcolare il layout adesso: senza,
         applicherebbe insieme "hidden via" e la traslazione e la transizione non
         partirebbe. Un requestAnimationFrame farebbe lo stesso, ma non scatta se
         la scheda non sta disegnando — e il menu deve aprirsi comunque. */
      void p.offsetHeight;
      p.classList.add("is-in");
      apertoOra = p;
      var primo = p.querySelector(".mnav-back");
      if (primo) primo.focus({ preventScroll: true });
    }

    function chiudiMenu() {
      mnav.classList.remove("is-open");
      /* Il <body> deve saperlo, come gia' succede col mega del desktop: sopra
         l'hero l'intestazione e' trasparente per scelta, ma col menu aperto
         quella trasparenza mostra il video dietro alle voci. La regola che la
         rende bianca guarda questa classe. */
      document.body.classList.remove("mnav-open");
      burger.setAttribute("aria-expanded", "false");
      burger.setAttribute("aria-label", "Apri menu");
      document.body.style.overflow = "";
      setTimeout(function () { mnav.hidden = true; chiudiLivello2(true); if (lv1) lv1.scrollTop = 0; }, 360);
    }

    burger.addEventListener("click", function () {
      if (mnav.classList.contains("is-open")) return chiudiMenu();
      mnav.hidden = false;
      void mnav.offsetHeight;      // vedi sopra: reflow forzato, non rAF
      mnav.classList.add("is-open");
      document.body.classList.add("mnav-open");
      burger.setAttribute("aria-expanded", "true");
      /* i due trattini diventano una croce: chi vede il disegno lo capisce da
         solo, chi si fa leggere la pagina deve sentirlo dire */
      burger.setAttribute("aria-label", "Chiudi menu");
      document.body.style.overflow = "hidden";
    });

    mnav.addEventListener("click", function (e) {
      var apriBtn = e.target.closest("[data-mnav-open]");
      if (apriBtn) return apri(apriBtn.getAttribute("data-mnav-open"));
      if (e.target.closest("[data-mnav-back]")) return chiudiLivello2();
      /* seguendo un collegamento il menu si chiude da solo */
      if (e.target.closest("a")) chiudiMenu();
    });

    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape" || !mnav.classList.contains("is-open")) return;
      if (apertoOra) chiudiLivello2(); else chiudiMenu();
    });
  }

  /* mega-menu */
  var megaEls = document.querySelectorAll(".mega");
  var navItems = document.querySelectorAll(".nav__item");
  function closeMega() { megaOpen = false; megaEls.forEach(function (m) { m.classList.remove("is-open"); }); document.body.classList.remove("mega-open"); refreshHeader(); }
  navItems.forEach(function (item) {
    item.addEventListener("mouseenter", function () {
      var key = item.getAttribute("data-mega");
      // Voce SENZA mega (es. Servizi, Taylor Made): chiudi qualsiasi mega aperto.
      if (!key) { closeMega(); return; }
      var any = false;
      megaEls.forEach(function (m) { var on = m.getAttribute("data-mega") === key; m.classList.toggle("is-open", on); if (on) any = true; });
      megaOpen = true; document.body.classList.toggle("mega-open", any); refreshHeader();
    });
  });
  /* LE VOCI CHE NON SONO LINK. "Gioielli" e' un bottone e non porta da nessuna
     parte: apre il menu e basta, perche' il catalogo in ordine sparso non deve
     essere raggiungibile in un clic. Col mouse ci pensa gia' il mouseenter qui
     sopra; chi arriva col Tab e preme Invio, senza questo, non attiverebbe
     niente. aria-expanded racconta lo stato a chi ascolta la pagina. */
  document.querySelectorAll("[data-apri-mega]").forEach(function (bt) {
    var key = bt.getAttribute("data-apri-mega");
    bt.addEventListener("click", function () {
      if (bt.getAttribute("aria-expanded") === "true") {
        closeMega(); bt.setAttribute("aria-expanded", "false"); return;
      }
      var any = false;
      megaEls.forEach(function (m) {
        var on = m.getAttribute("data-mega") === key;
        m.classList.toggle("is-open", on); if (on) any = true;
      });
      megaOpen = true;
      document.body.classList.toggle("mega-open", any);
      bt.setAttribute("aria-expanded", any ? "true" : "false");
      refreshHeader();
    });
  });

  if (header) header.addEventListener("mouseleave", closeMega);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeMega(); });

  /* mega preview: immagine emotiva a sinistra che cambia all'hover (tutti i mega) */
  document.querySelectorAll(".mega").forEach(function (mega) {
    var prev = mega.querySelector(".mega__preview img");
    if (!prev) return;
    var cap = mega.querySelector(".mega__preview-cap");
    var def = prev.getAttribute("src");
    var defCap = mega.getAttribute("data-default-cap") || "";
    /* Il cambio fotografia non e' piu' uno stacco secco: si spegne, si sostituisce
       a immagine invisibile, si riaccende. Un attimo di velo e' l'unica cosa che
       distingue un menu curato da uno che sfarfalla. */
    /* La fotografia cambia di colpo. La dissolvenza da 220 ms faceva aspettare
       per vedere la collezione che si sta puntando, e puntare e' un gesto
       rapido: si passa su tre voci e si vedono tre veli invece di tre foto. */
    function mostra(src, testo) {
      if (prev.getAttribute("src") === src) { if (cap) cap.textContent = testo; return; }
      prev.setAttribute("src", src);
      if (cap) cap.textContent = testo;
    }
    mega.querySelectorAll("[data-img]").forEach(function (el) {
      el.addEventListener("mouseenter", function () {
        mostra(el.getAttribute("data-img"), el.getAttribute("data-name") || defCap);
      });
    });
    mega.addEventListener("mouseleave", function () { mostra(def, defCap); });
  });

  /* ---------------- HERO scroll-scrub (canvas a fotogrammi) ---------------- */
  var hero = document.querySelector(".hero[data-hero]");
  if (hero) {
    var video = hero.querySelector(".hero__media");
    var canvas = hero.querySelector(".hero__canvas");
    // "Salta la schermata iniziale": niente logo da dissolvere e nessuno snap a p=0 dedicato,
    // il primo testo è già in scena al frame zero.
    var noIntro = hero.getAttribute("data-no-intro") === "true";
    var intro = noIntro ? null : hero.querySelector(".hero__intro");
    var vignette = hero.querySelector(".hero__vignette");
    var vigAlwaysOn = false;   // aggiornato da readOffset() leggendo --sc-vig-intro
    var cue = hero.querySelector(".hero__cue");
    var bar = hero.querySelector(".hero__bar");
    var beats = [].slice.call(hero.querySelectorAll(".beat"));
    var dots = [].slice.call(hero.querySelectorAll(".hero__dot"));
    var mobileCtas = hero.querySelector(".hero__mobile-ctas");

    // Lo scrub a canvas è SEMPRE attivo (desktop e mobile, anche con "riduci
    // animazioni" / risparmio energetico). Il video è solo fallback se manca il canvas.
    var coarse = window.matchMedia("(pointer: coarse)").matches;
    var heroMode = function () { return (!canvas) ? "mobile" : "desktop"; };
    var curMode = null, teardown = null;

    var buildMobile = function () {
      hero.classList.add("hero--mobile");
      if (video) { video.loop = true; video.muted = true; video.setAttribute("playsinline", ""); var pr = video.play(); if (pr && pr.catch) pr.catch(function () {}); }
      beats.forEach(function (b) { b.style.display = "none"; });
      if (cue) cue.style.display = "none";
      if (mobileCtas) mobileCtas.style.display = "flex";
      return function () { if (video) { try { video.pause(); } catch (e) {} } };
    };

    var buildDesktop = function () {
      hero.classList.remove("hero--mobile");
      beats.forEach(function (b) { b.style.display = ""; });
      if (cue) cue.style.display = "";
      if (mobileCtas) mobileCtas.style.display = "none";
      if (video) { try { video.pause(); } catch (e) {} }

      var ctx = canvas.getContext("2d", { alpha: false });
      var prefix = hero.getAttribute("data-frame-prefix") || "";
      // Sotto i 1024px usa il set leggero hero-m-* (720px): decodifica ~3x più veloce → più fluido su mobile.
      var useMobileFrames = window.innerWidth < 1024;
      var fname = (useMobileFrames && hero.getAttribute("data-frame-name-m")) || hero.getAttribute("data-frame-name") || "hero-f-";
      var fext = hero.getAttribute("data-frame-ext") || ".webp";
      var count = parseInt((useMobileFrames && hero.getAttribute("data-frame-count-m")) || hero.getAttribute("data-frame-count"), 10) || 216;
      var pad = parseInt(hero.getAttribute("data-frame-pad"), 10) || 3;
      var srcFor = function (i) { var s = String(i + 1); while (s.length < pad) s = "0" + s; return prefix + fname + s + fext; };

      var images = new Array(count), loaded = new Array(count), desired = 0, drawn = -1;
      var nearestLoaded = function (idx) {
        if (loaded[idx]) return idx;
        for (var d = 1; d < count; d++) {
          if (idx - d >= 0 && loaded[idx - d]) return idx - d;
          if (idx + d < count && loaded[idx + d]) return idx + d;
        }
        return -1;
      };
      // posizione del frame nel canvas (come object-position): 50% = centrato.
      // Regolabile dal pannello dev "Stile scrub" via --sc-pos-x / --sc-pos-y (anche per mobile via media query).
      var posX = 50, posY = 50, zoom = 100, tailF = 1;
      var readOffset = function () {
        var cs = getComputedStyle(hero);
        var x = parseFloat(cs.getPropertyValue("--sc-pos-x"));
        var y = parseFloat(cs.getPropertyValue("--sc-pos-y"));
        var z = parseFloat(cs.getPropertyValue("--sc-zoom"));
        posX = isNaN(x) ? 50 : x; posY = isNaN(y) ? 50 : y; zoom = isNaN(z) ? 100 : z;
        // senza schermata iniziale la sfumatura di fondo serve fin dal primo frame
        vigAlwaysOn = noIntro || parseFloat(cs.getPropertyValue("--sc-vig-intro")) === 1;
        var t = parseFloat(cs.getPropertyValue("--sc-tail"));
        tailF = 1 - (isNaN(t) ? 0 : Math.min(60, Math.max(0, t)) / 100);
        if (typeof rebuildSnaps === "function") rebuildSnaps();
      };
      var drawCover = function (im) {
        var cw = canvas.width, ch = canvas.height;
        var ir = im.naturalWidth / im.naturalHeight, cr = cw / ch, dw, dh;
        if (cr > ir) { dw = cw; dh = cw / ir; } else { dh = ch; dw = ch * ir; }
        var s = zoom / 100; if (s !== 1) { dw *= s; dh *= s; }
        var ox = (cw - dw) * (posX / 100);
        var oy = (ch - dh) * (posY / 100);
        ctx.drawImage(im, ox, oy, dw, dh);
      };
      function drawFrame(idx, force) {
        desired = idx;
        var use = nearestLoaded(idx);
        if (use < 0) return;
        if (use === drawn && !force) return;
        drawCover(images[use]); drawn = use;
      }
      for (var fi = 0; fi < count; fi++) {
        (function (i) {
          var im = new Image(); im.decoding = "async"; im.src = srcFor(i);
          im.onload = function () { loaded[i] = true; if (drawn < 0 || i === desired) drawFrame(desired, true); };
          images[i] = im;
        })(fi);
      }
      // Range di scroll in CACHE: calcolato al load/resize/orientationchange e NON
      // ad ogni scroll. Usa l'altezza dello sticky (100svh, stabile) invece di
      // window.innerHeight, che su mobile cambia con la barra indirizzi → niente jitter.
      var stickyEl = hero.querySelector(".hero__sticky");
      var heroTop = 0, range = 1;
      var measure = function () {
        heroTop = hero.getBoundingClientRect().top + (window.pageYOffset || window.scrollY || 0);
        var vh = stickyEl ? stickyEl.offsetHeight : window.innerHeight;
        range = Math.max(1, hero.offsetHeight - vh);
      };
      var sizeCanvas = function () {
        readOffset();
        // DPR limitato a 1.5 su mobile (canvas più piccolo → drawImage più rapido).
        var dpr = Math.min(window.devicePixelRatio || 1, useMobileFrames ? 1.5 : 2);
        canvas.width = Math.round(canvas.clientWidth * dpr);
        canvas.height = Math.round(canvas.clientHeight * dpr);
        drawn = -1;
      };

      // CODA FINALE (--sc-tail): frazione di scroll in cui il video resta fermo sull'ultimo frame.
      // Serve a dare respiro all'ultimo testo (Taylor Made), che altrimenti sfila via subito.
      // I valori data-from/to/snap dei beat sono espressi SUL VIDEO (0→1): qui li converto
      // in progresso di PAGINA moltiplicando per tailF, così restano allineati ai frame anche
      // cambiando la coda.
      // Con l'intro c'è uno snap in più a p=0 (il logo) e un pallino in più nella navigazione;
      // senza intro gli snap coincidono uno a uno con i beat.
      var snapsRaw = (noIntro ? [] : [0]).concat(beats.map(function (b) { return parseFloat(b.getAttribute("data-snap")); }));
      var snaps = snapsRaw.slice(), lastSnap = snaps[snaps.length - 1];
      var rebuildSnaps = function () {
        snaps = snapsRaw.map(function (v) { return v * tailF; });
        lastSnap = snaps[snaps.length - 1];
      };
      var snapping = false, snapTimer, activeSlide = -1;
      var edge = function (p, from, to) {
        if (p <= from || p >= to) return 0;
        var e = (to - from) * 0.26;
        if (p < from + e) return clamp((p - from) / e);
        if (p > to - e) return clamp((to - p) / e);
        return 1;
      };
      var progress = function () { return clamp(((window.pageYOffset || window.scrollY || 0) - heroTop) / range); };
      var scrollFor = function (p) { return heroTop + p * range; };
      var setActive = function (p) {
        var best = 0, bd = Infinity;
        for (var i = 0; i < snaps.length; i++) { var d = Math.abs(p - snaps[i]); if (d < bd) { bd = d; best = i; } }
        if (best !== activeSlide) { activeSlide = best; dots.forEach(function (el, i) { el.setAttribute("aria-current", i === best ? "true" : "false"); }); }
      };
      // NB: lo scostamento dell'animazione passa da VARIABILI CSS (--intro-shift / --beat-shift),
      // non da transform inline: così la POSIZIONE resta governata dal CSS (pannello "Stile scrub")
      // e le due cose non si annullano a vicenda.
      var apply = function (p) {
        if (intro) { var o = clamp(1 - p / 0.06); intro.style.opacity = o; intro.style.setProperty("--intro-shift", ((1 - o) * -14) + "px"); }
        // la sfumatura di fondo NON deve coprire la prima schermata (quella con il solo logo):
        // entra mentre l'intro svanisce. Con --sc-vig-intro:1 resta invece sempre visibile.
        if (vignette) vignette.style.setProperty("--vig-o", vigAlwaysOn ? 1 : clamp((p - 0.03) / 0.08));
        if (cue) cue.style.opacity = clamp(1 - p / 0.04);
        if (bar) bar.style.transform = "scaleX(" + p + ")";
        beats.forEach(function (b) {
          var o = edge(p, parseFloat(b.getAttribute("data-from")) * tailF, parseFloat(b.getAttribute("data-to")) * tailF);
          b.style.opacity = o; b.style.setProperty("--beat-shift", ((1 - o) * 18) + "px");
          b.style.pointerEvents = o > 0.5 ? "auto" : "none";
        });
      };
      var ticking = false;
      var update = function () {
        ticking = false;
        var p = progress();
        // i frame si esauriscono a p = tailF: l'ultima porzione di scroll è la "coda" ferma
        drawFrame(Math.round(clamp(p / tailF) * (count - 1)));
        apply(p); setActive(p);
      };
      var doSnap = function () {
        if (snapping) return;
        var p = progress();
        if (p <= 0.006 || p >= lastSnap + 0.012) return;
        var target = snaps[0], bd = Infinity;
        snaps.forEach(function (sp) { var d = Math.abs(p - sp); if (d < bd) { bd = d; target = sp; } });
        if (Math.abs(p - target) < 0.006) return;
        snapping = true;
        window.scrollTo({ top: scrollFor(target), behavior: "smooth" });
        window.setTimeout(function () { snapping = false; }, 850);
      };
      // Snap consentito solo su desktop con puntatore fine (mouse) e finestra ampia.
      // Su touch o schermi stretti: nessuno snap → scorrimento libero e fluido, e il
      // logo torna semplicemente scorrendo in cima (niente calamita che lo scavalca).
      var snapAllowed = function () { return !coarse && window.innerWidth >= 900; };
      var onScroll = function () {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
        if (snapAllowed()) { clearTimeout(snapTimer); snapTimer = setTimeout(doSnap, 150); }
      };
      dots.forEach(function (el, i) {
        el.addEventListener("click", function () {
          snapping = true; window.scrollTo({ top: scrollFor(snaps[i]), behavior: "smooth" });
          window.setTimeout(function () { snapping = false; }, 850);
        });
      });
      measure();
      sizeCanvas();
      update();
      var remeasure = function () { measure(); sizeCanvas(); update(); };
      // esposto al pannello dev "Stile scrub": ridisegna il frame con l'offset/zoom aggiornati
      // update() ricalcola anche opacità/posizione (sfumatura, testi), poi forzo il ridisegno del frame
      window.CurnisHero = { refresh: function () { readOffset(); update(); drawFrame(desired, true); } };
      window.addEventListener("scroll", onScroll, { passive: true });
      var ro = null;
      if (typeof ResizeObserver !== "undefined") { ro = new ResizeObserver(remeasure); ro.observe(canvas); }
      window.addEventListener("resize", remeasure);
      window.addEventListener("orientationchange", remeasure);
      return function () {
        window.removeEventListener("scroll", onScroll);
        window.removeEventListener("resize", remeasure);
        window.removeEventListener("orientationchange", remeasure);
        if (ro) ro.disconnect();
      };
    };

    var applyMode = function () {
      var m = heroMode();
      if (m === curMode) return;
      if (teardown) { teardown(); teardown = null; }
      curMode = m;
      teardown = (m === "mobile") ? buildMobile() : buildDesktop();
    };
    applyMode();
    var heroModeT;
    window.addEventListener("resize", function () { clearTimeout(heroModeT); heroModeT = setTimeout(applyMode, 200); });
  }
  refreshHeader();

  /* ---------------- REVEAL ---------------- */
  var reveals = document.querySelectorAll(".reveal");
  if (reveals.length) {
    var showEl = function (el) { el.classList.add("is-in"); };
    if (reduced || !("IntersectionObserver" in window)) {
      reveals.forEach(showEl);
    } else {
      var rio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { showEl(e.target); rio.unobserve(e.target); } });
      }, { threshold: 0.16, rootMargin: "0px 0px -8% 0px" });
      reveals.forEach(function (el) { rio.observe(el); });
      // fallback: se l'IO non scatta (es. tab in background), mostra comunque ciò che è già in viewport
      var revealSafety = function () {
        reveals.forEach(function (el) {
          if (el.classList.contains("is-in")) return;
          var r = el.getBoundingClientRect();
          if (r.top < window.innerHeight * 0.92 && r.bottom > 0) { showEl(el); rio.unobserve(el); }
        });
      };
      window.addEventListener("load", function () { setTimeout(revealSafety, 300); });
      window.addEventListener("scroll", revealSafety, { passive: true });
      setTimeout(revealSafety, 1600);
    }
  }

  /* ---------------- WISHLIST (locale) ---------------- */
  var WK = "curnis_wishlist";
  var getWish = function () { try { return JSON.parse(localStorage.getItem(WK) || "[]"); } catch (e) { return []; } };
  var setWish = function (a) { try { localStorage.setItem(WK, JSON.stringify(a)); } catch (e) {} };
  var updateCount = function () { var c = getWish().length; document.querySelectorAll("[data-wish-count]").forEach(function (el) { el.textContent = c > 0 ? c : ""; el.style.display = c > 0 ? "" : "none"; }); };
  var syncHearts = function () { var w = getWish(); document.querySelectorAll("[data-wish]").forEach(function (b) { b.classList.toggle("is-active", w.indexOf(b.getAttribute("data-wish")) >= 0); }); };
  document.querySelectorAll("[data-wish]").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault(); e.stopPropagation();
      var id = btn.getAttribute("data-wish"); var w = getWish(); var i = w.indexOf(id);
      if (i >= 0) w.splice(i, 1); else w.push(id);
      setWish(w); syncHearts(); updateCount();
    });
  });
  syncHearts(); updateCount();

  /* ---------------- GALLERY prodotto ---------------- */
  var pmain = document.querySelector("[data-product-main]");
  if (pmain) {
    var thumbs = [].slice.call(document.querySelectorAll(".pd-thumb-in"));
    var cur = 0;
    var showImg = function (i) {
      if (!thumbs.length) return;
      cur = (i + thumbs.length) % thumbs.length;
      var btn = thumbs[cur];
      pmain.setAttribute("src", btn.getAttribute("data-full") || btn.getAttribute("data-thumb"));
      thumbs.forEach(function (b, j) { b.classList.toggle("is-active", j === cur); });
      if (btn.scrollIntoView) btn.scrollIntoView({ inline: "center", block: "nearest" });
    };
    thumbs.forEach(function (btn, i) { btn.addEventListener("click", function () { showImg(i); }); });
    var gprev = document.querySelector("[data-gallery-prev]");
    var gnext = document.querySelector("[data-gallery-next]");
    if (gprev) gprev.addEventListener("click", function () { showImg(cur - 1); });
    if (gnext) gnext.addEventListener("click", function () { showImg(cur + 1); });
  }

  /* ---------------- VARIANTE prodotto ---------------- */
  var vselect = document.querySelector("[data-variant-select]");
  if (vselect) {
    vselect.addEventListener("change", function () {
      var opt = vselect.options[vselect.selectedIndex];
      /* IL PIENO BARRATO SEGUE LA VARIANTE. Si costruiscono i nodi invece di
         incollare marcatura: i due valori arrivano dal nostro formattatore, ma
         un innerHTML qui sarebbe una porta aperta per sempre. */
      var priceEl = document.querySelector("[data-variant-price]");
      if (priceEl && opt.getAttribute("data-price")) {
        var pieno = opt.getAttribute("data-full");
        priceEl.textContent = "";
        if (pieno) {
          var s = document.createElement("s");
          s.className = "prezzo-pieno";
          s.textContent = pieno;
          priceEl.appendChild(s);
          priceEl.appendChild(document.createTextNode(" "));
        }
        priceEl.appendChild(document.createTextNode(opt.getAttribute("data-price")));
      }
      var addBtn = document.querySelector("[data-add-btn]");
      if (addBtn) {
        var avail = opt.getAttribute("data-available") === "true";
        addBtn.disabled = !avail;
        addBtn.textContent = avail ? addBtn.getAttribute("data-label") : "Non disponibile";
      }
    });
  }

  /* ---------------- POP-UP (dopo 60s, una volta a sessione) ---------------- */
  var popupRoot = document.querySelector("[data-popup]");
  if (popupRoot) {
    var SEEN = "curnis_popup_shown";
    var seen = false;
    try { seen = sessionStorage.getItem(SEEN) === "1"; } catch (e) {}
    if (!seen) {
      var isWatches = popupRoot.getAttribute("data-watches") === "true";
      var modal = document.getElementById(isWatches ? "popup-orologi" : "popup-consulenza");
      var delay = parseInt(popupRoot.getAttribute("data-delay"), 10) || 60000;
      if (modal) {
        var openPopup = function () {
          try { sessionStorage.setItem(SEEN, "1"); } catch (e) {}
          modal.querySelectorAll("img[data-src]").forEach(function (im) { if (!im.getAttribute("src")) im.src = im.getAttribute("data-src"); });
          modal.hidden = false;
          void modal.offsetWidth;
          modal.classList.add("is-open");
          document.body.style.overflow = "hidden";
          document.body.classList.add("popup-open");   // sfoca davvero il contenuto dietro
        };
        var closePopup = function () {
          modal.classList.remove("is-open");
          document.body.style.overflow = "";
          document.body.classList.remove("popup-open");
          window.setTimeout(function () { modal.hidden = true; }, 460);
        };
        window.setTimeout(openPopup, delay);
        modal.querySelectorAll("[data-close]").forEach(function (el) { el.addEventListener("click", closePopup); });
        document.addEventListener("keydown", function (e) { if (e.key === "Escape" && modal.classList.contains("is-open")) closePopup(); });
      }
    }
  }
})();

/* ══════════════════ MISURA: I GESTI, IN UN POSTO SOLO ══════════════════
   (Prima di aggiungere un blocco simile: cercare QUESTA intestazione. Due
   ascoltatori vogliono dire ogni clic contato due volte.)

   PERCHE' UNO SOLO. I collegamenti a telefono, WhatsApp ed email sono in
   ventotto punti del tema. Toccarli uno per uno sono ventotto occasioni di
   sbagliare, e ogni pulsante nuovo nascerebbe non misurato. Qui si guarda un
   clic sul documento e si vede dove e' finito.
   Si ascolta in cattura e non si ferma niente: il collegamento fa il suo
   lavoro esattamente come prima.

   COSA VA AL PIXEL E COSA NO. Vanno il canale (whatsapp/telefono/email), la
   posizione (piede, menu, pastiglia...) e l'indirizzo della pagina. NON vanno
   il numero di telefono ne' l'indirizzo email: sono i nostri, e non
   aggiungono niente a un rapporto. */
(function () {
  function pubblica(nome, dati) {
    dati.pagina = location.pathname;
    /* assoluto e senza query: il pixel gira in una sandbox e da solo non sa
       su quale pagina si trova */
    dati.href = location.origin + location.pathname;
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === "function") {
        Shopify.analytics.publish(nome, dati);
      }
    } catch (e) {}
  }

  function posizione(el) {
    if (el.closest(".wa-fab") || el.closest(".dfab")) return "pastiglia";
    if (el.closest(".mnav") || el.closest("header")) return "menu";
    if (el.closest("footer")) return "piede";
    if (el.closest("[data-lnz-bon]")) return "lista-nozze";
    if (el.closest(".cp3-flot")) return "scheda-pietra";
    if (el.closest(".ct-voce")) return "contatti";
    return "pagina";
  }

  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    /* IL QR DI WHATSAPP DEL COMPUTER. Non e' un collegamento: e' un pulsante
       che apre un codice da inquadrare, e sul desktop e' l'unico gesto
       WhatsApp che esiste (la pastiglia accanto porta ai contatti, non a
       wa.me). Senza questa riga, su computer WhatsApp risulterebbe a zero. */
    if (t.closest("[data-waqr-apri]")) {
      pubblica("curnis:contatto", { canale: "whatsapp", posizione: "pastiglia-qr" });
      return;
    }

    var a = t.closest("a[href]");
    if (!a) return;
    var href = a.getAttribute("href") || "";
    var canale = "";
    if (href.indexOf("tel:") === 0) canale = "telefono";
    else if (href.indexOf("mailto:") === 0) canale = "email";
    else if (href.indexOf("wa.me") > -1) canale = "whatsapp";
    if (!canale) return;
    pubblica("curnis:contatto", { canale: canale, posizione: posizione(a) });
  }, true);

  /* IL BIGLIETTO DELLA NEWSLETTER. Il ponte moduli aggancia solo i moduli con
     il campo «Tipo modulo», e questo non ce l'ha: e' un modulo cliente. Senza
     biglietto l'iscrizione non verrebbe mai annunciata, e con la ricarica
     della pagina del grazie verrebbe annunciata ogni volta. Si riconosce dal
     campo dei tag, che e' suo e di nessun altro. */
  var nl = document.querySelector('form input[name="contact[tags]"][value="newsletter"]');
  if (nl && nl.form) {
    nl.form.addEventListener("submit", function () {
      try {
        sessionStorage.setItem("curnis_modulo_ok", JSON.stringify({ tipo: "Newsletter", t: Date.now() }));
      } catch (e) {}
    });
  }
})();

/* ---------------- RICERCA CON SUGGERIMENTI (prodotti + pagine + popolari) ----------------
   Il gruppo degli articoli e' spento dal 14 settembre 2026, quando il Journal e'
   uscito dal sito: l'indice manda "articles":[] e le righe che disegnano le
   schede articolo non si accendono mai. Sono lasciate apposta — se un giorno il
   blog torna, basta rimettere gli articoli nell'indice. */
(function () {
  var ov = document.querySelector("[data-search]");
  if (!ov) return;
  var input = ov.querySelector("[data-search-input]");
  var results = ov.querySelector("[data-search-results]");
  var data = { products: [], articles: [], pages: [], suggest: [] };
  try {
    var parsed = JSON.parse(ov.querySelector("[data-search-index]").textContent || "{}");
    if (Array.isArray(parsed)) data.products = parsed; else data = Object.assign(data, parsed);
  } catch (e) {}
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function n(s) { return (s || "").toLowerCase(); }

  function prodCard(p) {
    var img = p.img ? '<span class="sr-thumb"><img src="' + esc(p.img) + '" alt="" loading="lazy"></span>' : '<span class="sr-thumb sr-thumb--empty"></span>';
    return '<a class="sr-prod" href="' + esc(p.u) + '">' + img +
      '<span class="sr-prod-tx"><span class="sr-prod-t">' + esc(p.t) + '</span>' +
      (p.v ? '<span class="sr-prod-v">' + esc(p.v) + '</span>' : '') + '</span>' +
      (p.pr ? '<span class="sr-prod-pr">' + esc(p.pr) + '</span>' : '') + '</a>';
  }
  function artCard(a) {
    var img = a.img ? '<span class="sr-athumb"><img src="' + esc(a.img) + '" alt="" loading="lazy"></span>' : '';
    return '<a class="sr-art" href="' + esc(a.u) + '">' + img +
      '<span class="sr-art-tx">' + (a.c ? '<span class="sr-art-c">' + esc(a.c) + '</span>' : '') +
      '<span class="sr-art-t">' + esc(a.t) + '</span></span></a>';
  }
  function pageRow(p) { return '<a class="sr-page" href="' + esc(p.u) + '"><span class="sr-page-i" aria-hidden="true">&rarr;</span>' + esc(p.t) + '</a>'; }
  function chip(s) { return '<button type="button" class="sr-chip" data-chip="' + esc(s) + '">' + esc(s) + '</button>'; }
  function group(title, inner, cls) { return '<div class="sr-group"><p class="sr-group-t">' + esc(title) + '</p><div class="' + cls + '">' + inner + '</div></div>'; }

  function bindChips() {
    results.querySelectorAll("[data-chip]").forEach(function (b) {
      b.addEventListener("click", function () { input.value = b.getAttribute("data-chip"); input.dispatchEvent(new Event("input")); input.focus(); });
    });
  }
  /* IL PANNELLO DI PARTENZA E' FATTO DI SOLE PAROLE (19 settembre 2026).
     Prima mostrava anche quattro gioielli «che potrebbero interessarti», in
     una griglia a due colonne con fotografia e prezzo: tanta roba prima
     ancora che qualcuno avesse scritto una lettera, e su uno schermo stretto
     quella griglia sbordava di lato. Fuori tutte e due, e con loro il
     Journal, che era comunque sempre vuoto.
     Restano due file di parole: quelle che CERCANO e quelle che PORTANO. */
  function vaiChip(v) {
    return '<a class="sr-chip sr-chip--vai" href="' + esc(v.u) + '">' +
      '<span class="sr-chip-i" aria-hidden="true">&rarr;</span>' + esc(v.t) + '</a>';
  }
  function renderDefault() {
    var html = "";
    if (data.suggest && data.suggest.length)
      html += '<div class="sr-group"><p class="sr-group-t">Cerca fra i prodotti</p><div class="sr-chips">' + data.suggest.map(chip).join("") + '</div></div>';
    if (data.vai && data.vai.length)
      html += '<div class="sr-group"><p class="sr-group-t">Vai direttamente a</p><div class="sr-chips">' + data.vai.map(vaiChip).join("") + '</div></div>';
    results.innerHTML = html;
    bindChips();
  }
  /* IL CATALOGO LO CERCA SHOPIFY, non piu' un elenco stampato in pagina.

     Prima i prodotti venivano da data.products, cioe' dal riquadro JSON che
     sections/header.liquid stampa nell'intestazione: un ciclo su
     collections['all'].products, che fuori da una paginazione si ferma a
     cinquanta. Su un catalogo di centinaia di pezzi la tendina ne cercava
     cinquanta, sempre gli stessi, e il peso lo pagava OGNI pagina del sito.

     I campi su cui cercare vanno detti a mano: di serie Shopify guarda
     titolo, tipo prodotto, titolo variante e fornitore, e su questo catalogo
     il tipo prodotto e' vuoto sul 96% dei pezzi e il fornitore e' un
     promemoria di laboratorio («ORO 18 KT», «---»). Con titolo, fornitore e
     tag, chi scrive «diamanti» trova i diamanti. */
  var SUG = "/search/suggest";
  var NASCOSTE = [];
  try {
    var _el = ov.querySelector("[data-search-index]");
    if (_el) {
      SUG = _el.getAttribute("data-suggest") || SUG;
      NASCOSTE = (_el.getAttribute("data-nascoste") || "").split(",")
        .map(function (x) { return x.trim(); }).filter(Boolean);
    }
  } catch (e) {}
  var volo = null, attesa = null;

  /* IL PREZZO DELLA TENDINA. La ricerca di Shopify lo manda come testo, e le
     due forme possibili si riconoscono dal punto decimale: «4100.00» sono
     euro, «410000» sono centesimi. Sbagliare di cento volte e' il genere di
     errore che si vede subito, quindi qui si guarda il punto invece di
     fidarsi. Lo spazio prima del simbolo e' unito: in fondo a una riga
     stretta l'euro non deve restare da solo. */
  function euro(v) {
    var t = String(v == null ? "" : v);
    if (!t) return "";
    var x = t.indexOf(".") > -1 ? parseFloat(t) : parseInt(t, 10) / 100;
    if (!isFinite(x) || x <= 0) return "Su richiesta";
    return x.toLocaleString("it-IT", { maximumFractionDigits: 0 }) + " €";
  }

  /* LA RETE: gli otto prodotti ancora stampati nell'intestazione. Serve
     quando la chiamata non parte — rete assente, troppe richieste di fila. */
  function locale(q) {
    return (data.products || []).filter(function (p) {
      return n(p.t).indexOf(q) > -1 || n(p.v).indexOf(q) > -1;
    }).slice(0, 6);
  }

  function cercaProdotti(q, poi) {
    if (volo) { try { volo.abort(); } catch (e) {} }
    volo = (typeof AbortController !== "undefined") ? new AbortController() : null;
    var u = SUG + ".json?q=" + encodeURIComponent(q) +
            "&resources[type]=product&resources[limit]=6" +
            "&resources[options][fields]=title,vendor,tag";
    fetch(u, { signal: volo ? volo.signal : undefined, credentials: "same-origin" })
      .then(function (r) { if (!r.ok) throw new Error("http"); return r.json(); })
      .then(function (d) {
        var lista = ((((d || {}).resources || {}).results || {}).products) || [];
        poi(lista
          .filter(function (p) {
            /* LA QUOTA DELLA LISTA NOZZE NON DEVE USCIRE QUI.
               La risposta di Shopify non porta i tag, quindi l'etichetta
               «nascosto» non si puo' guardare: si va di maniglie, scritte a
               mano in sections/header.liquid. */
            return NASCOSTE.indexOf(p.handle) < 0;
          })
          .slice(0, 6)
          .map(function (p) {
            return {
              t: p.title,
              v: p.vendor === "Curnis" ? "" : (p.vendor || ""),
              u: p.url,
              img: p.image ? (p.image + (p.image.indexOf("?") > -1 ? "&" : "?") + "width=200") : "",
              pr: euro(p.price)
            };
          }));
      })
      .catch(function (e) { if (!e || e.name !== "AbortError") poi(locale(q)); });
  }

  function disegna(pr, q) {
    /* se nel frattempo si e' continuato a scrivere, questa risposta non e'
       piu' la risposta alla domanda che c'e' nella casella */
    if (n(input.value.trim()) !== q) return;
    var pg = (data.pages || []).filter(function (p) { return n(p.t).indexOf(q) > -1; }).slice(0, 4);
    var ar = (data.articles || []).filter(function (a) { return n(a.t).indexOf(q) > -1 || n(a.c).indexOf(q) > -1; }).slice(0, 4);
    var html = "";
    if (pr.length) html += group("Prodotti", pr.map(prodCard).join(""), "sr-prods");
    if (pg.length) html += group("Pagine", pg.map(pageRow).join(""), "sr-pages");
    if (ar.length) html += group("Articoli", ar.map(artCard).join(""), "sr-arts");
    if (!html) { results.innerHTML = '<p class="search-ov__empty">Nessun risultato. Premi Invio per cercare “' + esc(input.value) + '”.</p>'; return; }
    results.innerHTML = html;
  }

  /* LA CLASSE SUL BODY SERVE AL VELO. Il contenuto della pagina va sfocato
     davvero con un filter — il backdrop-filter da solo non sfoca i testi — e
     quel contenuto sta fuori dalla ricerca: l'unico modo di raggiungerlo e'
     una classe in alto. E' la gemella di «mega-open», stessa ricetta. */
  var svuota = ov.querySelector("[data-search-clear]");
  function mostraSvuota() { if (svuota) svuota.hidden = !(input && input.value.length); }
  function open() { ov.hidden = false; document.body.classList.add("search-open"); document.body.style.overflow = "hidden"; renderDefault(); mostraSvuota(); setTimeout(function () { input && input.focus(); }, 30); }
  function close() { ov.hidden = true; document.body.classList.remove("search-open"); document.body.style.overflow = ""; if (input) input.value = ""; results.innerHTML = ""; mostraSvuota(); }
  if (svuota) svuota.addEventListener("click", function () {
    if (!input) return;
    input.value = ""; mostraSvuota(); renderDefault(); input.focus();
  });
  document.querySelectorAll("[data-search-open]").forEach(function (b) { b.addEventListener("click", open); });
  ov.querySelectorAll("[data-search-close]").forEach(function (b) { b.addEventListener("click", close); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !ov.hidden) close(); });
  if (input) input.addEventListener("input", function () {
    var q = n(input.value.trim());
    mostraSvuota();
    clearTimeout(attesa);
    if (q.length < 2) { if (volo) { try { volo.abort(); } catch (e) {} } renderDefault(); return; }
    /* UN RESPIRO FRA UN TASTO E L'ALTRO. A una chiamata per lettera Shopify
       risponde di no, e la tendina resterebbe vuota senza dire niente. */
    attesa = setTimeout(function () { cercaProdotti(q, function (pr) { disegna(pr, q); }); }, 200);
  });
})();
